import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_manubot-connect/artifacts/7tyngri3_base_logo_transparent_background.png" 
              alt="Manubot Logo" 
              className="h-12 md:h-14 brightness-200"
            />
            <p className="text-sm mb-4 max-w-md">
              {mockData.company.description}
            </p>
            <div className="flex flex-col space-y-2">
              <a 
                href={`mailto:${mockData.company.email}`}
                className="flex items-center space-x-2 text-sm hover:text-white transition-colors"
              >
                <Mail className="h-4 w-4" />
                <span>{mockData.company.email}</span>
              </a>
              <a 
                href={`https://wa.me/${mockData.company.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-sm hover:text-white transition-colors"
              >
                <Phone className="h-4 w-4" />
                <span>+55 11 98187-7765</span>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navegação</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/produto" className="text-sm hover:text-white transition-colors">
                  Produto
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="text-sm hover:text-white transition-colors">
                  Sobre
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-sm hover:text-white transition-colors">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Recursos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/produto" className="text-sm hover:text-white transition-colors">
                  Funcionalidades
                </Link>
              </li>
              <li>
                <Link to="/produto" className="text-sm hover:text-white transition-colors">
                  Integrações
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-sm hover:text-white transition-colors">
                  Suporte
                </Link>
              </li>
              <li>
                <a 
                  href={`https://${mockData.company.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-white transition-colors"
                >
                  Website
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>
            © {currentYear} {mockData.company.name}. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;